import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const IdleContext = createContext();

const IDLE_TIMEOUT_MINUTES = parseInt(process.env.REACT_APP_IDLE_TIMEOUT_MINUTES) || 15;
const IDLE_TIMEOUT_MS = IDLE_TIMEOUT_MINUTES * 60 * 1000;
const WARNING_MS = 60 * 1000;

export const IdleProvider = ({ children }) => {
  const [showWarning, setShowWarning] = useState(false);
  const navigate = useNavigate();
  const timerRef = useRef(null);
  const warningTimerRef = useRef(null);
  const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];

  const logout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate('/login');
    setShowWarning(false);
  };

  const resetTimer = () => {
    clearTimeout(timerRef.current);
    clearTimeout(warningTimerRef.current);
    setShowWarning(false);
    timerRef.current = setTimeout(() => {
      setShowWarning(true);
      warningTimerRef.current = setTimeout(() => {
        logout();
      }, WARNING_MS);
    }, IDLE_TIMEOUT_MS - WARNING_MS);
  };

  useEffect(() => {
    const handleActivity = () => resetTimer();
    events.forEach(event => window.addEventListener(event, handleActivity));
    resetTimer();
    return () => {
      events.forEach(event => window.removeEventListener(event, handleActivity));
      clearTimeout(timerRef.current);
      clearTimeout(warningTimerRef.current);
    };
  }, []);

  const value = { showWarning, setShowWarning, logout };

  return (
    <IdleContext.Provider value={value}>
      {children}
    </IdleContext.Provider>
  );
};

export const useIdle = () => useContext(IdleContext);